(function () {
    'use strict';

    angular
        .module('sod-logger')
        .constant('SodEnvironmentContants', {
            'PRODUCTION': 'production',
            'DEVELOPMENT': 'development',
            'LOCALHOST': 'localhost',
            'RELEASE': 'release',
            'LOCALHOSTPRODUCTION': 'localhostproduction'
        })
        .provider('SodLogger', SodLogger);

    function SodLogger() {
        let environment = 'production';
        return {
            config: (_env) => {
                environment = _env;
            },
            getEnvironment: () => {
                return environment;
            },
            $get: SodLoggerFactory
        };
    }

    function SodLoggerFactory(SodEnvironmentContants) {
        const vm = this;
        vm.logLevel = {
            'DEBUG': 'debug',
            'INFO': 'info',
            'WARNING': 'warning',
            'ERROR': 'error'
        };
        return {
            debug: function() {
                log2(vm.logLevel.DEBUG, arguments);
            },
            info: function() {
                log2(vm.logLevel.INFO, arguments);
            },
            warn: function() {
                log2(vm.logLevel.WARNING, arguments);
            },
            error: function() {
                log2(vm.logLevel.ERROR, arguments);
            },
            log: () => {
                log(vm.logLevel.DEBUG, '', arguments);
            },
            LOG_LEVEL: vm.logLevel
        };

        function log2(loglevel, args) {
            const title = args[0];
            log(loglevel, title, Array.prototype.slice.call(args, 1));
        }

        function log(level, title, msg) {
            if (!title) { title = ''; }

            const env = vm.getEnvironment();
            switch (env) {
                case SodEnvironmentContants.PRODUCTION:

                    break;
                case SodEnvironmentContants.RELEASE:
                case SodEnvironmentContants.DEVELOPMENT:
                case SodEnvironmentContants.LOCALHOST:
                case SodEnvironmentContants.LOCALHOSTPRODUCTION:
                    // consoleLog(level, title.toUpperCase(), msg);
                    break;
            }

            if (env.indexOf(SodEnvironmentContants.LOCALHOST) >= 0) {
                consoleLog(level, title.toUpperCase(), msg);
            }
        }

        function consoleLog() {
            if (!console) return ;
            const level = arguments[0];
            const title = arguments[1];

            const label = '%c## ' + level.toUpperCase() + ((title.length > 0) ? (' : ' + title + ' ##') : ' ##');
            // const args = Array.prototype.slice.call(arguments, 2);
            const args = arguments[2];
            let color = '#fff';
            let type = 'log';

            switch (level) {
                case vm.logLevel.DEBUG:
                    color = '#1abc9c';
                    break;
                case vm.logLevel.INFO:
                    color = '#95a5a6';
                    break;
                case vm.logLevel.WARNING:
                    color = '#e67e22';
                    type = 'warn';
                    break;
                case vm.logLevel.ERROR:
                    color = '#c0392b';
                    type = 'error';
                    break;
            }

            // console[type].apply(null, [label, 'color: ' + color].concat(Array.prototype.slice.call(args))); // eslint-disable-line no-console
            // console.trace(); // eslint-disable-line no-console
        }
    }
})();